import API from "@/api/lib/api";

export const getAllChristmas = async (restaurant_id) => {
  try {
    const response = await API.get(
      `restaurant/${restaurant_id}/christmas-lunches`
    );
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getSingleChristmas = async (id) => {
  try {
    const response = await API.get(`restaurant/christmas-lunches/${id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const createChristmas = async (data) => {
  try {
    const response = await API.post(`restaurant/christmas-lunches`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const updateChristmas = async (id, data) => {
  try {
    const response = await API.put(`restaurant/christmas-lunches/${id}`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const deleteChristmas = async (id) => {
  try {
    const response = await API.delete(`restaurant/christmas-lunches/${id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
